import { servicesConfig } from "./servicesConfig";

export const calculatePriceByService = (serviceName, tons) => {
  if (!serviceName) return 0;

  const service = servicesConfig[serviceName];
  if (!service) return 0;

  const pricePerTon = service.price;
  const total = pricePerTon * (tons / 20);

  return Math.round(total);
};